import { HyperFormula } from 'hyperformula';
export default {
    formulas: {
        engine: HyperFormula,
    },
    lazyFormula(cells) {
        for(let cell in cells) {
            cell = cells[cell]
            let row = cell[0]
            let col = cell[1]
            let value = cell[2]
            for(let formula in this.formulas) {
                if (value.indexOf(formula.formula)>=0) {
                    let callBack = formula.callBack
                }
            }
        }
    },
    lazyFormulaTotal(value) {

    },
    setCellMeta(hot, key, value, start, end) {

    },
    setHeight(container, field) {
       if (field.value !== undefined) {
           let length = field.value.length
           let height = (length * 30) + 'px'
           container.style.height = height
       }
    },
    init(container, field) {
        container.hotInstance = new Handsontable(container, {
            stretchH: 'all',
            autoWrapRow: true,
            autoWrapCol: true,
            data: field.value,
            mergeCells: field.data.spreadsheet.settings.mergeCells,
            colWidths: field.data.spreadsheet.settings.colWidths,
            cell: field.data.spreadsheet.settings.cellMetas,
            rowHeaders: true,
            colHeaders: true,
            manualRowResize: false,
            manualRowMove: true,
            manualColumnResize: true,
            height: '300',
            formulas: {
                engine: HyperFormula,
            },
            licenseKey: 'non-commercial-and-evaluation',
            customBorders: true,
            contextMenu: {
                items: {
                    'undo': {},
                    'redo': {},
                    'sep1': "---------",
                    'make_read_only': {},
                    'alignment': {},
                    'mergeCells': {},
                    'sep2': "---------",
                    'row_above': {},
                    'row_below': {},
                    'remove_row': {},
                    'sep3': "---------",
                    'col_left': {},
                    'col_right': {},
                    'clear_column': {},
                    'borders': {}
                }
            },
            beforeChange: function (changes, source) {
                if (undefined != changes[0] && undefined != changes[0][3]) {
                    let value = changes[0][3];
                    let row = changes[0][0];
                    let col = changes[0][1];

                    if (value.length > 35) {

                        this.setCellMeta(row, col, 'className', 'maxlength-error');
                    }
                    else {
                        this.setCellMeta(row, col, 'className', '');
                    }
                }
            },
            afterChange: function (data, b, c) {

                if (data !== null && data[0] !== undefined) {
                    data = data[0]
                    let row = data[0]
                    let col = data[1]
                    let value = data[3]

                    let tCalcul = false
                    let tCalculDecimal = 0
                    let tCalculTXT = false
                    let tCompleteTotal = false

                    if(value) {
                        if (value.toLowerCase() === 't') {
                            tCalcul = true
                            tCalculTXT = true
                        }

                        if (value.toLowerCase() === 't2') {
                            tCalcul = true
                            tCalculDecimal = 2
                            tCalculTXT = true
                        }

                        if (value.toLowerCase() === 't3') {
                            tCalcul = true
                            tCalculDecimal = 3
                            tCalculTXT = true
                        }

                        if (value.toLowerCase() === 'total') {
                            tCalcul = true
                            tCalculTXT = true
                            tCompleteTotal = true
                        }

                        if (value.toLowerCase() === 'total2') {
                            tCalcul = true
                            tCalculDecimal = 2
                            tCalculTXT = true
                            tCompleteTotal = true
                        }

                        if (value.toLowerCase() === 'total3') {
                            tCalcul = true
                            tCalculDecimal = 3
                            tCalculTXT = true
                            tCompleteTotal = true
                        }

                        if (value.toLowerCase() === 'tt') {
                            tCalcul = true
                            tCalculDecimal = 2
                            tCalculTXT = true
                            tCompleteTotal = true
                        }

                        if (value.toLowerCase() === 'ttt') {
                            tCalcul = true
                            tCalculDecimal = 3
                            tCalculTXT = true
                            tCompleteTotal = true
                        }
                    }

                    if (tCalcul) {
                        let go = true
                        let total = 0
                        let backRow = row
                        while (go) {
                            backRow = backRow - 1;
                            if (backRow < 0) {
                                go = false
                            } else {
                                let rowValue = this.getDataAtCell(backRow, col);
                                if (!isNaN(rowValue) && '' != rowValue && null != rowValue) {
                                    total += parseFloat(rowValue);
                                }
                                else {
                                    go = false;
                                }
                            }
                        }
                        if (tCalculTXT) {
                            let totalTXT = 'T: '
                            if (tCompleteTotal) {
                                totalTXT = 'Total: '
                            }
                            this.setDataAtCell(parseInt(row), col, totalTXT + parseFloat(total).toFixed(tCalculDecimal));
                        } else {
                            this.setDataAtCell(parseInt(row), col, parseFloat(total).toFixed(tCalculDecimal).toString());
                        }

                    }

                }
            }
        });

        container.hotInstance.updateSettings({
            enterMoves: function() {
                if (container.hotInstance.getSelected()[1] === (container.hotInstance.countCols() - 1)) {
                    container.hotInstance.selectCell((container.hotInstance.getSelected()[0] + 1), 0);
                    return {
                        row: 0,
                        col: 0
                    }
                } else {
                    return {
                        row: 0,
                        col: 1
                    }
                }
            }
        });

        this.setHeight(container, field)

        return container
    },
    extractData(hotTable) {
        if(hotTable.hotInstance.getData !== undefined) {
            return hotTable.hotInstance.getSourceData()
        }
        return []
    },
    extractSettings(hotTable) {
        let colWidths = []
        let mergeCells = []
        let cellMetas = []

        if(hotTable.hotInstance.getPlugin('mergeCells').mergedCellsCollection !== undefined)
        {
            mergeCells = hotTable.hotInstance.getPlugin('mergeCells').mergedCellsCollection.mergedCells
        }

        if(hotTable.hotInstance.getCellsMeta !== undefined) {
            let hotTableCellsMeta = hotTable.hotInstance.getCellsMeta()

            for(let hotTableCellMetaIndex in hotTableCellsMeta) {
                let hotTableCellMeta = hotTableCellsMeta[hotTableCellMetaIndex]

                if(hotTableCellMeta !== undefined) {

                    let cellMeta = {
                        row: 0,
                        col: 0,
                        readOnly: false,
                        className: '',
                        colWidth: 0
                    }

                    if (hotTableCellMeta.readOnly !== undefined) {
                        cellMeta.readOnly = hotTableCellMeta.readOnly
                    }

                    if (hotTableCellMeta.className !== undefined) {
                        cellMeta.className = hotTableCellMeta.className
                    }

                    if (hotTableCellMeta.row !== undefined) {
                        cellMeta.row = hotTableCellMeta.row
                    }

                    if (hotTableCellMeta.col !== undefined) {
                        if (hotTableCellMeta.row === 0) {
                            colWidths[hotTableCellMeta.col] = hotTable.hotInstance.getCellMeta(hotTableCellMeta.row, hotTableCellMeta.col).instance.getColWidth(hotTableCellMeta.col)
                        }
                        cellMeta.col = hotTableCellMeta.col
                    }

                    if (cellMeta.readOnly === true || cellMeta.className !== '') {
                        cellMetas.push(cellMeta)
                    }
                }
            }
        }

        let cellSettings = {
            mergeCells: mergeCells,
            colWidths: colWidths,
            cellMetas: cellMetas
        }

        return cellSettings
    }
}